export const PASSPORT_NUMBER_ERROR =
  'Invalid passport number. Use 6-20 letters and numbers, no spaces or special characters.';

export const PASSPORT_NUMBER_REGEX = /^[A-Za-z0-9]{6,20}$/;

export const normalizePassportNumber = (value?: string): string => (value ?? '').trim();

export const validatePassportNumber = (value?: string): true | string => {
  const normalized = normalizePassportNumber(value);

  if (!normalized) {
    return 'ID number is required';
  }

  return PASSPORT_NUMBER_REGEX.test(normalized) ? true : PASSPORT_NUMBER_ERROR;
};
